import React from 'react';
import { MzcrSharedHealthRecord } from '@meddihub/mzcr-ui';
import MzcrPatientService, {
	MzcrPatientServiceRenderProps,
} from '../../../Mzcr/Components/MzcrPatientService';
import { getMzcrClient } from '../../../Mzcr/Services/mzcrClient';
import useMzcrAnamnesis from '../../../Mzcr/Services/useMzcrAnamnesis';

interface Props {
	patientId: string;
	/** Switches to the Anamnéza sub-tab ("Otevřít anamnézu" in the comparison). */
	onOpenAnamnesis?: () => void;
}

/** The record with the anamnesis - the anamnesis is loaded only once the service is shown. */
const SharedHealthRecordWithAnamnesis: React.FC<
	Props & { service: MzcrPatientServiceRenderProps }
> = ({ patientId, onOpenAnamnesis, service }) => {
	const anamnesis = useMzcrAnamnesis(patientId, onOpenAnamnesis);

	return (
		<MzcrSharedHealthRecord
			mzcrClient={getMzcrClient()}
			{...service}
			anamnesis={anamnesis}
		/>
	);
};

/** Sdílený zdravotní záznam (MZČR) in Léčba, next to Anamnéza – designs S1–S7. */
const PatientTreatmentSharedHealthRecord: React.FC<Props> = ({
	patientId,
	onOpenAnamnesis,
}) => (
	<MzcrPatientService patientId={patientId}>
		{service => (
			<SharedHealthRecordWithAnamnesis
				key={service.rid}
				patientId={patientId}
				onOpenAnamnesis={onOpenAnamnesis}
				service={service}
			/>
		)}
	</MzcrPatientService>
);

export default PatientTreatmentSharedHealthRecord;
